var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "vlt-modal",
    {
      staticClass: "modal",
      attrs: {
        "can-cancel": _vm.canCancel,
        "ok-text": _vm.okText,
        title: _vm.title,
        visible: _vm.visible,
        large: _vm.large,
        "no-footer": _vm.noFooter,
      },
      on: { close: _vm.close, confirm: _vm.confirm },
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }